
import { isNodeJS, getGlobal } from "../compat";

export const DtRegionalHosts = {
  dev: {
    "us": "dtw-stg.autodesk.com"
  },
  stg: {
    "us": "tandem-stg.autodesk.com",
    "eu": "eu.tandem-stg.autodesk.com"
  },
  prod: {
    "us": "tandem.autodesk.com",
    "eu": "eu.tandem.autodesk.com",
    "aus": "aus.tandem.autodesk.com"
  }
};

const TandemRegion2ApsRegion = {
  "us": "US",
  "eu": "EMEA",
  "aus": "AUS"
};

// note that tandem URLs here are not regionalized
const ApsUrl2TandemBaseUrl = {
  "https://developer-stg.api.autodesk.com/tandem/v1": "https://tandem-stg.autodesk.com/api/v1",
  "https://developer.api.autodesk.com/tandem/v1": "https://tandem.autodesk.com/api/v1"
};

function envFromUrl(url) {
  const u = new URL(url);
  const host = u.host;

  for (let env in DtRegionalHosts) {
    for (let region in DtRegionalHosts[env]) {
      if (DtRegionalHosts[env][region] === host) {
        return env;
      }
    }
  }
}

const isApsUrl = (url) => {
  return Boolean(ApsUrl2TandemBaseUrl[url]);
};

// replaces a hostname in the supplied url to match desired region
function changeRegion(url, targetRegion) {
  // get current environment SDK connected to
  const tandemEnv = envFromUrl(url);
  if (!tandemEnv) {
    console.log("Failed to regionalize URL - just use given one", url);
    // in some tests scenarios urls can't be regionalized(e.g. when using docker network), so we return the original url
    return url;
  }
  const u = new URL(url);
  // find corresponding hostname for the desired region
  u.host = DtRegionalHosts[tandemEnv][targetRegion];
  return u.toString();
}

const _window = getGlobal();

var endp = {};

var CDN_ROOT = null;
endp.ENDPOINT_API_TANDEM_V1 = 'dt';

var _apis_data = {
  [endp.ENDPOINT_API_TANDEM_V1]: {
    baseURL: '/modeldata',
    itemURL: '/modeldata/:derivativeurn',
    //thumbnailsURL: '/derivativeservice/v2/thumbnails/:urn',
    cdnURL: '/cdn',
    cdnWS: '/cdnws',
    msgWS: '/msgws',
    fragsWS: '/fragsws'
  }
};
// Default endpoint, effectively pointing to tandem's global APIs (non region specific)
var _endpoint = '';
var _api = endp.ENDPOINT_API_TANDEM_V1;
var _useCredentials = false;
var _useCookie = false;

endp.HTTP_REQUEST_HEADERS = {};
endp.queryParams = {};

/**
 * Sets the endpoint and api to be used to create REST API request strings.
 * @param {string} endpoint
 * @param {string} [api] - Possible values are derivativeV2, modelDerivativeV2
 */
endp._setEndpointAndApi = function (endpoint, api) {
  if (endpoint) {
    _endpoint = endpoint;
  }
  if (api) {
    _api = api;
  }
};

/**
 * Returns the endpoint used to create REST API request strings.
 * Examples: "developer.api.autodesk.com"
 * @returns {string}
 */
endp._getApiEndpoint = function () {
  return _endpoint;
};

/**
 * @private
 * @returns {string}
 */
endp.getApiFlavor = function () {
  return _api;
};

/**
 * Returns the default shared resource CDN location.
 * For best performance (and to not overload our servers), this should
 * be replaced by a direct CloudFront url during initialization, by
 * calling the cdnRedirectUrl and looking at the result.
 */
endp._getCdnUrl = function () {
  var host = _endpoint;
  // websockets are not supported on APS yet, so we fall back to our direct URLs
  if (ApsUrl2TandemBaseUrl[host]) {
    host = ApsUrl2TandemBaseUrl[host];
  }
  return CDN_ROOT || (host ? host + _apis_data[_api].cdnURL : undefined);
};

endp._getWebSocketEndpoint = function (which) {
  var host = _endpoint;
  if (ApsUrl2TandemBaseUrl[host]) {
    host = ApsUrl2TandemBaseUrl[host];
  }
  return host + (_apis_data[_api][which] || '');
};

/**
 * Returns a REST API request strings to be used to get a derivative urn.
 * Example: "developer.api.autodesk.com/modelderivative/v2/designdata/:urn/manifest/:derivativeUrn"
 * @param {string} endpoint
 * @param {string} derivativeUrn
 * @param {string} api - When provided is used instead of the globally set API flavor
 * @returns {string}
 */
endp.getItemApi = function (endpoint, derivativeUrn, api) {
  var theApi = api || _api;
  var itemApi = endpoint + _apis_data[theApi].itemURL;
  // If urn is not provided we return same string that before for backward compatibility.
  derivativeUrn = derivativeUrn || '';

  itemApi = itemApi.replace(':derivativeurn', derivativeUrn);

  return itemApi;
};

endp.getUseCredentials = function () {
  return _useCredentials;
};

/**
 * Adds a URL parameter that will be used in all data load requests.
 * @param {string} param - The name of the parameter
 * @param {string} value - The value of the parameter. It will be URI encoded when constructing the final URL.
 */
endp.addQueryParam = function (param, value) {
  this.queryParams[param] = value;
};

/**
 * Deletes a previously specified URL parameter.
 * @param {string} param - The name of the parameter to delete
 */
endp.deleteQueryParam = function (param) {
  delete this.queryParams[param];
};

endp.getQueryParams = function (inputObj) {

  let qParam = inputObj.api !== "dt" && this.getUseCredentials() && !isNodeJS() ? "domain=" + encodeURIComponent(_window.location.origin) : "";

  let addedParams = [];
  for (let p in this.queryParams) {
    addedParams.push(encodeURIComponent(p) + "=" + encodeURIComponent(this.queryParams[p]));
  }

  if (addedParams.length) {
    if (qParam)
    qParam += "&" + addedParams.join("&");else

    qParam = addedParams.join("&");
  }

  if (qParam && inputObj) {
    if (inputObj.queryParams) {
      inputObj.queryParams += "&" + qParam;
    } else {
      inputObj.queryParams = qParam;
    }
  }

  return qParam;
};

endp.setUseCredentials = function (useCredentials) {
  _useCredentials = useCredentials;
};

endp.setUseCookie = function (useCookie) {
  _useCookie = useCookie;
};

endp.getUseCookie = function () {
  return _useCookie;
};

// supposed to be only called once on app initialization - all subsequent requests should use their respective load contexts
endp.initLoadContext = function (inputObj) {

  inputObj = inputObj || {};

  inputObj.auth = this.getUseCredentials();

  if (!inputObj.endpoint)
  inputObj.endpoint = this._getApiEndpoint();

  if (!inputObj.api)
  inputObj.api = this.getApiFlavor();

  if (!inputObj.headers)
  inputObj.headers = {};

  for (var p in this.HTTP_REQUEST_HEADERS) {
    inputObj.headers[p] = this.HTTP_REQUEST_HEADERS[p];
  }

  //This is done to avoid CORS errors on content served from proxy or browser cache
  //The cache will respond with a previously received response, but the Access-Control-Allow-Origin
  //response header might not match the current Origin header (e.g. localhost vs. developer.api.autodesk.com)
  //which will cause a CORS error on the second request for the same resource.
  this.getQueryParams(inputObj);

  //shared geometry/material storage
  inputObj.otg_cdn = CDN_ROOT || this._getCdnUrl();
  inputObj.otg_ws = this._getWebSocketEndpoint("cdnWS");
  inputObj.msg_ws = this._getWebSocketEndpoint("msgWS");
  inputObj.frags_ws = this._getWebSocketEndpoint("fragsWS");

  return inputObj;
};

endp.switchRegion = function (inputObj, region) {
  if (!region.length) {
    region = "us";
  }

  if (inputObj.otg_cdn) {
    inputObj.otg_cdn = changeRegion(inputObj.otg_cdn, region);
  }

  if (inputObj.otg_ws) {
    inputObj.otg_ws = changeRegion(inputObj.otg_ws, region);
  }

  if (inputObj.msg_ws) {
    inputObj.msg_ws = changeRegion(inputObj.msg_ws, region);
  }

  if (inputObj.frags_ws) {
    inputObj.frags_ws = changeRegion(inputObj.frags_ws, region);
  }

  // APS regional targets must be specified via header, rather than via URL overwrite
  if (isApsUrl(inputObj.endpoint)) {
    // TODO: this does not really work yet, because "headers" is global for the app and passed in as a reference - need to find a better way.
    // inputObj.headers["region"] = TandemRegion2ApsRegion[region];
    console.error("APS env is not supported yet");
    return;
  } else {
    inputObj.endpoint = changeRegion(inputObj.endpoint, region);

  }
};

endp.getSupportedRegions = function () {
  // This is a little hacky because we do not store environment(dev/stg/prod) anywhere, but it's always possible to derive it from the URL
  let endpoint = endp._getApiEndpoint();

  if (isApsUrl(endpoint)) {
    // if it is an APS url, we need to map it back to tandem environment to see what regions are supported within this environment
    endpoint = ApsUrl2TandemBaseUrl[endpoint];
  }

  const regionalTargets = DtRegionalHosts[envFromUrl(endpoint)];
  return regionalTargets ? Object.keys(regionalTargets) : ['us'];
};

// used to list all "required" properties of the load context
const dummyCtx = endp.initLoadContext({});
// load contexts are arbitrary objects in Tandem SDK and can contain either non-serializable data
// or things that are not really needed to be passed to lower level code (e.g feature flags)
// most of the time we do not care, but when needed, we can sanitize it
endp.copySanitizedLoadContext = function (sanitizedLoadContext, fullLoadContext) {
  // match behavior of initLoadContext, to be able to merge query params
  this.getQueryParams(sanitizedLoadContext);

  if (!sanitizedLoadContext.headers)
  sanitizedLoadContext.headers = {};

  // match behavior of initLoadContext, to be able to merge headers
  const headers = { ...this.HTTP_REQUEST_HEADERS, ...fullLoadContext.headers };
  for (var p in headers) {
    sanitizedLoadContext.headers[p] = headers[p];
  }

  for (let key in dummyCtx) {
    if (!sanitizedLoadContext[key]) {
      sanitizedLoadContext[key] = fullLoadContext[key];
    }
  }
};

//TODO: Globals that need a better place
var _env; //formerly avp.env
export function getEnv() {
  return _env;
}
export function setEnv(env) {
  _env = env;
}

// Set viewer in offline mode if set to true. In offline mode, viewer would ignore all URNs in bubble JSON
// and assume the viewables are laid out in local file system path relative to the bubble.json.
var _offline = false;
export function isOffline() {
  return _offline;
}
export function setOffline(offline) {
  _offline = offline;
}

export let endpoint = endp;

//For backwards compatibility until all code is converted to use
//the function from the endpoint instance.
export let initLoadContext = endp.initLoadContext.bind(endp);
export let copySanitizedLoadContext = endp.copySanitizedLoadContext.bind(endp);